import {InsolesTypeFamilySummaryModel} from '../family/insolesTypeFamilySummary.model';
import {ValueAndLabelModel} from '../../../../../../common/model/valueAndLabel.model';

export class InsolesTypeSummaryModel extends ValueAndLabelModel{
    family: InsolesTypeFamilySummaryModel;
}
